import * as React from 'react';
export const miniPlayerSvg = React.forwardRef(function miniPlayerSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 3.75V2.5A1.5 1.5 0 0 1 5.5 1h9A1.5 1.5 0 0 1 16 2.5v7a1.5 1.5 0 0 1-1.5 1.5h-1v1.75A2.25 2.25 0 0 1 11.25 15h-9A2.25 2.25 0 0 1 0 12.75V6a2.25 2.25 0 0 1 2.25-2.25H4ZM5.5 2.5h9v7h-9v-7ZM12 11H5.5A1.5 1.5 0 0 1 4 9.5V5.25H2.25A.75.75 0 0 0 1.5 6v6.75c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75V11Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.806 5.534a.384.384 0 0 1 0 .667L9.587 7.45C9.328 7.594 9 7.411 9 7.12V4.634a.39.39 0 0 1 .587-.33l2.219 1.23Z',
    }),
  );
});
miniPlayerSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var miniPlayer = {
  category: 'icon',
  colorable: true,
  name: 'miniPlayer',
  svg: miniPlayerSvg,
};
